import React from "react";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import EstimateProjectForm from "../../WebDevelopmentPage/EstimateProjectForm";

const SmsIntroSection: React.FC = () => {
  return (
    <section className="wdev-intro sms-intro" aria-labelledby="sms-intro-title">
      <div className="container">
        <div className="wdev-intro__grid">
          <AnimatedSection className="wdev-intro__content">
            <span className="wdev-label wdev-label--purple">School Management Software</span>
            <h2 id="sms-intro-title" className="wdev-intro__title">
              School Management Software Development
            </h2>

            <p className="wdev-intro__text">
              As the entire nation is rapidly moving towards digitization, still there are few
              industries which are hesitating to adapt themselves completely — and the academic
              industry is one among them. Even though the system is gradually changing towards
              digitization and innovative preaching, the management part still remains in the dark.
              There are only a few educational institutions who have adopted complete digitization.
              The prevailing trend of high expenditure towards related software is one big reason
              behind this hesitation.
            </p>
            <p className="wdev-intro__text">
              As a software service provider, we find this as a huge gap and feel that it can be
              rectified. We take this as an opportunity to provide a school management software
              which acts as a one-stop solution for the entire administrative process. The software
              developed by us helps you run your institute in a much better way by providing an
              opportunity for real growth.
            </p>
            <p className="wdev-intro__text">
              This entire school management system is divided into two categories — server-based
              and mobile app-based — depending purely upon the user.
            </p>
          </AnimatedSection>

          <AnimatedSection className="wdev-intro__form-wrap" delay={0.15}>
            <EstimateProjectForm />
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default SmsIntroSection;
